exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto:300,400,500,700);", ""]);

// module
exports.push([module.id, "@media only screen and (min-width: 600px) {\n  .dialog-content {\n    min-width: 350px; } }\n\n@media only screen and (max-width: 600px) {\n  .dialog-content {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    min-width: 300px; }\n    .dialog-content .flex-column div.flex {\n      -ms-flex-direction: column;\n      flex-direction: column; }\n    .dialog-content .grid-item {\n      padding-top: 0 !important;\n      padding-bottom: 0 !important; } }\n\n@media only screen and (max-width: 400px) {\n  .dialog-content {\n    min-width: 150px; } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/screens/clients/create/index.scss
// module id = 1191
// module chunks = 0